import AppConstants from '../config/app.constants';

let ItemService = function ($http, $q) {

    const create = (data) => {
        return $http
            .post(AppConstants.api + `/item/create`, data)
            .then((res) => {
                return res.data
            })
    }

    const getItemTypes = (typeId, searchText, limit, offset) => {
        return $http
            .get(AppConstants.api + `/item/get-item-types`, { params: { typeId, searchText, limit, offset } })
            .then((res) => {
                return res.data
            })
    }

    const getItemList = (branchId, searchText, limit, offset, sortASC, sortColumn, selectedItemStatus) => {
        return $http
            .get(AppConstants.api + `/item/get-item-list`, { params: { branchId, searchText, limit, offset, sortASC, sortColumn, selectedItemStatus } })
            .then((res) => {
                return res.data
            })
    }

    const update = (id, data) => {
        return $http
            .post(AppConstants.api + `/item/${id}`, { data })
            .then((res) => {
                return res.data
            })
    }

    const getItem = (id) => {
        return $http
            .get(AppConstants.api + `/item/${id}`)
            .then((res) => {
                return res.data
            })
    }

    const logisticItemAssign = (branchId, barcode, userId, routeId, notes, keepRouteAssignment, userKey, itemId, entryType) => {
        return $http
            .post(AppConstants.api + `/item/logistic-item-assign`, { branchId, barcode, userId, routeId, notes, keepRouteAssignment, userKey, itemId, entryType })
            .then((res) => {
                return res.data
            })
    }

    const logisticItemHold = (branchId, barcode, userId) => {
        return $http
            .post(AppConstants.api + `/item/logistic-item-hold`, { branchId, barcode, userId })
            .then((res) => {
                return res.data
            })
    }

    const logisticItemDelete = (branchId, barcode, userId) => {
        return $http
            .post(AppConstants.api + `/item/logistic-item-delete`, { branchId, barcode, userId })
            .then((res) => {
                return res.data
            })
    }

    const availableRoutes = (branchId) => {
        return $http
            .get(AppConstants.api + `/item/available-routes`, {
                params: { branchId }
            })
            .then((res) => {
                return res.data
            })
    }

    const logisticItemHoldRelease = (branchId, barcode, userId, routeId, note) => {
        return $http
            .post(AppConstants.api + `/item/logistic-item-hold-release`, { branchId, barcode, userId, routeId, note })
            .then((res) => {
                return res.data
            })
    }

    const logisticItemCheckOut = (branchId, barcode, userId) => {
        return $http
            .post(AppConstants.api + `/item/logistic-item-check-out`, { branchId, barcode, userId })
            .then((res) => {
                return res.data
            })
    }

    const logisticItemCheckIn = (branchId, barcode, userId, keepRouteAssignment) => {
        return $http
            .post(AppConstants.api + `/item/logistic-item-check-in`, { branchId, barcode, userId, keepRouteAssignment })
            .then((res) => {
                return res.data
            })
    }

    const logisticItemBulkHold = (routeId, branchId, vaultDate, userId, itemList) => {
        return $http
            .post(AppConstants.api + `/item/logistic-item-bulk-hold`, { routeId, branchId, vaultDate, userId, itemList })
            .then((res) => {
                return res.data
            })
    }

    const logisticItemReAssign = (branchId, barcode, userId, routeId, notes, itemAssignmentId, userKey, itemId, entryType) => {
        return $http
            .post(AppConstants.api + `/item/logistic-item-re-assign`, { branchId, barcode, userId, routeId, notes, itemAssignmentId, userKey, itemId, entryType })
            .then((res) => {
                return res.data
            })
    }

    const logisticItemForceAdd = (branchId, barcode, userId, routeId, notes, keepRouteAssignment, userKey) => {
        return $http
            .post(AppConstants.api + `/item/logistic-item-force-add`, { branchId, barcode, userId, routeId, notes, keepRouteAssignment, userKey })
            .then((res) => {
                return res.data
            })
    }

    const undoItemAssignment = (branchId, barcode, userId, routeId, itemAssignmentId, userKey, itemId, entryType) => {
        return $http
            .post(AppConstants.api + `/item/undo-item-assignment`, { branchId, barcode, userId, routeId, itemAssignmentId, userKey, itemId, entryType })
            .then((res) => {
                return res.data
            })
    }

    const getItemHistory = (itemId, limit, offset, sortASC, sortColumn) => {
        return $http
            .get(AppConstants.api + `/item/get-item-history`, { params: { itemId, limit, offset, sortASC, sortColumn } })
            .then((res) => {
                return res.data
            })
    }

    let exportItemHistory = (itemId, sortASC, sortColumn) => {
        return $http
            .post(AppConstants.api + `/item/export-item-history`, { itemId, sortASC, sortColumn })
            .then((res) => {
                return res.data
            })
    }

    const logisticItemLost = (branchId, barcode, userId, itemId, entryType, routeId, userKey ) => {
        return $http
            .post(AppConstants.api + `/item/logistic-item-lost`, { branchId, barcode, userId, itemId, entryType, routeId, userKey  })
            .then((res) => {
                return res.data
            })
    }

    const logisticItemReturnAvailable = (branchId, barcode, userId, itemId, entryType, routeId, userKey ) => {
        return $http
            .post(AppConstants.api + `/item/logistic-item-return-available`, { branchId, barcode, userId, itemId, entryType, routeId, userKey  })
            .then((res) => {
                return res.data
            })
    }

    return {
        create, getItemTypes, getItemList, update, getItem, availableRoutes,
        logisticItemAssign, logisticItemHold, logisticItemDelete,
        logisticItemHoldRelease, logisticItemCheckOut, logisticItemCheckIn,
        logisticItemBulkHold, logisticItemReAssign, logisticItemForceAdd,
        undoItemAssignment, getItemHistory, exportItemHistory, logisticItemLost, logisticItemReturnAvailable
    };
};

ItemService.$inject = ['$http', '$q']

export default ItemService;



// WEBPACK FOOTER //
// ./client/app/services/item.service.js